module.exports = __webpack_public_path__ + "static/media/mascote.47aef42d.png";